import { useCookies } from 'react-cookie'
import { makeIgnoredStepsKey } from '../../helpers'
import { useMemo } from 'react'

type Props = {
  categoryId: string
  stepKeys: string[]
}

type IgnoredStepsCookie = {
  [key: string]: string[]
}

export const useAssessmentSteps = ({
  categoryId,
  stepKeys,
}: Props): string[] => {
  const [cookies] = useCookies<string, IgnoredStepsCookie>([
    makeIgnoredStepsKey(categoryId),
  ])

  const filteredStepKeys = useMemo(() => {
    const ignoredSteps = cookies?.[makeIgnoredStepsKey(categoryId)] || []
    return stepKeys.filter((step) => !ignoredSteps.includes(step))
  }, [cookies, stepKeys, categoryId])

  return filteredStepKeys
}
